import React, { useContext } from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'
import IconMessageButton from '~/components/MainMenu/IconMessageButton'
import IconSearchButton from '~/components/MainMenu/IconSearchButton'
import Logo from '~/components/MainMenu/Logo'
import MainMenuMobile from '~/components/MainMenu/Mobile'
import NavHorizontal from '~/components/MainMenu/NavHorizontal'
import UserAccountControl from '~/components/MainMenu/UserAccountControl'
import ToolsBlock from '~/components/MainMenu/ToolsBlock'

const HeaderLayout = ({ children }) => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)

   return (
      <>
         <MainMenuMobile />
         <View
            display="none[a-c] flex[d-f]"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            height={theme.tmpHeaderHeight}
            backgroundColor={theme.tmpMainMenuBackgroundColor}
            borderBottom={`1px solid ${theme.tmpMainMenuBorderColor}`}
            paddingHorizontal={theme.tmpViewportPadding}
            zIndex="2">
            <View display="flex" alignItems="center" flex="1 1 auto">
               <Logo />
               <View width="30px" height="40px" />
               <NavHorizontal display="flex" flex="0 0 auto" />
            </View>
            <View display="flex" alignItems="center" flex="0 0 auto">
               <IconSearchButton color={theme.tmpMainMenuTextColor} size="20px" />
               <View width="25px" height="40px" />
               <IconMessageButton color={theme.tmpMainMenuTextColor} size="18px" />
               <View
                  display="none[a-c] flex[d-f]"
                  justifyContent="center"
                  alignItems="center"
                  flex="0 0 auto"
                  marginLeft="5px"
                  width="40px"
                  height="40px">
                  <View
                     width="1px"
                     height="24px"
                     backgroundColor={theme.tmpMainMenuTextColor}
                     opacity="0.2"
                  />
               </View>
               <UserAccountControl />
               <ToolsBlock popoverAnchorOriginVertical="top" />
            </View>
         </View>
         <View
            width="100%"
            height={theme.tmpViewportHeight}
            display="block[a-c] flex[d-f]"
            scroll="on">
            <View width="100%">
               {children}
            </View>
         </View>
      </>
   )
}

HeaderLayout.propTypes = {
   children: PropTypes.node.isRequired
}

export default HeaderLayout
